<ion-grid class="center">
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336" *ngIf="getStudentsList$ | async as students">
				<ng-container *ngIf="students.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container>
				<ng-container *ngIf="!students.isSkeleton">
					<ion-row>
						<ion-col col="12">
							<dx-data-grid id="gridContainer" [dataSource]="students.data" keyExpr="email"
								[allowColumnResizing]="true" [columnAutoWidth]="true" [showBorders]="true">
								<dxo-search-panel [visible]="true" [width]="240"
									placeholder="Search..."></dxo-search-panel>
								<dxo-header-filter [visible]="true"></dxo-header-filter>
								<dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
								<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

								<dxi-column caption="Actions" dataField="id" [allowFiltering]="false"
									[allowSorting]="false" cellTemplate="cellTemplate" [width]="150" [fixed]="true">
								</dxi-column>

								<dxi-column dataField="userName" caption="User Name"></dxi-column>
								<dxi-column dataField="firstName" caption="First Name"></dxi-column>
								<dxi-column dataField="lastName" caption="Last Name"></dxi-column>
								<dxi-column dataField="email" caption="Email"></dxi-column>

								<dxi-column caption="Onboarding" dataField="onboarding"
									cellTemplate="cellTemplateOnboarding">
								</dxi-column>

								<div *dxTemplate="let d of 'cellTemplate'">
									<a (click)="updatePassword(d.data)" class="cursor">Update Password</a>
								</div>


								<div *dxTemplate="let d of 'cellTemplateOnboarding'">

									<div class="dx-field">
										<div class="dx-field-value">
											<dx-check-box [value]="!!d.data.onBoarding"
												(onValueChanged)="updateStudentOnboarding(d.data, $event)"></dx-check-box>
										</div>
									</div>

									<!-- 									
									<p appConfirmBox (learnDelete)="updateStudentOnboarding(d.data.email)"
										title="Update onboarding" buttonText="Yes, Confirm"
										subTitle="Are you sure you want to complete Onboarding ?"
										class="Body_S text-right cursor">
										Update Onboarding
									</p> -->
								</div>

								<dxo-toolbar>
									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<ion-button (click)="createStudents()"><ion-icon
													name="add-outline"></ion-icon></ion-button>
										</div>
									</dxi-item>

									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<p class="Heading_M">Add New B2B Student</p>
										</div>
									</dxi-item>

									<dxi-item name="columnChooserButton"></dxi-item>

									<dxi-item name="searchPanel"></dxi-item>
								</dxo-toolbar>
							</dx-data-grid>
						</ion-col>
					</ion-row>
				</ng-container>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>